<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 ml-0 md:ml-4 aarni-font">Avenues for success@ARNI</h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>

        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white aarni-font ">
            <h2 class="text-2xl font-bold mb-4">Avenues for success@ARNI</h2>
            <div class="flex flex-col md:flex-row items-center py-6">
                <div class="w-full md:w-3/10 flex justify-center items-center">
                    <img src='assets/img/admissions/migration.png' alt="Description"
                         class="h-60 w-60 rounded-lg object-cover">
                </div>
                <div class="w-full md:w-7/10">
                    <h2 class="font-semibold text-xl my-2">Migration up to 5th Semester</h2>
                    <p class="text-gray-700 text-justify text-gray-800">
                        The promise that there will be no barriers to study is genuinely fulfilled by ARNI University.
                        We provide a distinctive migration policy in keeping with this. Candidates must have
                        successfully finished two years of study in the same field at any other university or
                        institution, whether Indian or foreign, in order to be admitted to the fifth semester of any
                        academic program. If a student has previously appeared in any course at the university from
                        which they are moved, they will not be transferred. A NOC from the institution or university
                        where the candidate is currently enrolled must be shown. Such migration will depend on the
                        number of seats available in the programs or branches where migration is desired. The policies
                        and procedures of ARNI University will control migration.
                    </p>
                    <button
                        (click)="goTo('form/apply-form')"
                        class="bg-green-400 text-white font-semibold px-6 py-2 rounded-full hover:bg-green-500 transition duration-300 my-4">
                        Apply Now
                    </button>
                </div>
            </div>
            <div class="flex flex-col md:flex-row items-center py-6">
                <div class="w-full md:w-7/10">
                    <h2 class="font-semibold text-xl my-2">100% Scholarship for 100 Innovative Ideas</h2>
                    <p class="text-gray-700 text-justify text-gray-800">
                        We at ARNI University are a proud stakeholder in the Honorable Prime Minister’s vision of a
                        self-reliant India by nourishing young minds and nurturing job creators instead of job seekers.
                        To support our enthusiastic youth, we offer upto 100% scholarships and seed funding to
                        innovative ideas that have the potential to make it big under the guidance of our innovation &
                        launchpad cell. You are encouraged to share your ideas through our official email ID-
                        info@arniuniversity.edu.in. Our initiative to fund ideas helps more than 50 alumni to set up
                        their careers in business operations and entrepreneurship in several sectors. Our student
                        launchpad is well-structured and recognized by the government.
                    </p>
                    <button
                        (click)="goTo('form/apply-form')"
                        class="bg-green-400 text-white font-semibold px-6 py-2 rounded-full hover:bg-green-500 transition duration-300 my-4">
                        Apply Now
                    </button>
                </div>
                <div class="w-full md:w-3/10 flex justify-center items-center">
                    <img src='assets/img/admissions/scholarship.png' alt="Description"
                         class="h-60 w-60 rounded-lg object-cover">
                </div>
            </div>

        </section>
    </div>

</div>
